import { ON_HOLD } from '../api/Constants';
import { CRED_SECRET_KEY } from '../credSecretKey' 
const CryptoJS = require('crypto-js');

export function getAccessKeyValue(type) {
  let string = "";
  if (type === "aws") {
    string = process.env.REACT_APP_AWS_ACCESS_KEY;
  } else if (type === "digitalOcean") {
    string = process.env.REACT_APP_DIGITALOCEAN_ACCESS_KEY;
  }

  return CryptoJS.AES.decrypt(string, CRED_SECRET_KEY).toString(CryptoJS.enc.Utf8);
}

export function getSecretKeyValue(type) {
  let string = "";
  if (type === "aws") {
    string = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
  } else if (type === "digitalOcean") {
    string = process.env.REACT_APP_DIGITALOCEAN_SECRET_KEY;
  }

  return CryptoJS.AES.decrypt(string, CRED_SECRET_KEY).toString(CryptoJS.enc.Utf8);
}

/**
 * @description
 * This function determines whether a card should be processed as editing status
 * @param {Object} user - contains user roles
 * @param {Object} card - contains card details
 * @returns {Boolean} - true if card should be processed as editing status
 */
export function shouldProcessEditing(admin, subAdmin, is_complete, sourceStatus) {
  if (admin) return true;
  if (is_complete === '1') {
    return false;
  } else {
    if (sourceStatus === ON_HOLD && !subAdmin) {
      return true;
    }
    return false;
  }
}

export const GOOGLE_DRIVE_LINK_ERROR_MESSAGE = "Google Drive links are not acceptable. Please provide DigitalOcean video link.";

export function isGoogleDriveLink(url) {
  if (!url || typeof url !== 'string') return false;
  return url.toLowerCase().includes('drive.google.com');
}

export function hasGoogleDriveLink(mainUrl, urlArray = []) {
  if (isGoogleDriveLink(mainUrl)) {
    return true;
  }
  if (Array.isArray(urlArray)) {
    return urlArray.some(item => {
      if (!item) return false;
      if (typeof item === 'string') {
        return isGoogleDriveLink(item);
      }
      if (typeof item === 'object' && item.url) {
        return isGoogleDriveLink(item.url);
      }
      return false;
    });
  }
  return false;
}
